import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';
import { Endi, Movi, Sald } from 'src/app/model/scc.model';


@Injectable({
  providedIn: 'root'
})
export class TarefasContratoSccService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/scc';
  }
  //-------------INCLUSÃO--------------// 

  public incluirContrato(idSistema: number, numeroContrato: number, cnpjAgenteFinanceiro: string, controleMCF: boolean): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/endi/${idSistema}/${numeroContrato}/cnpj-agente/${cnpjAgenteFinanceiro}?controleMCF=${controleMCF}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public incluirSaldoDePrincipal(idSistema: number, numeroContrato: number, saldo: Sald): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/sald/${idSistema}/${numeroContrato}`, saldo, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  
  public incluirMovimento(idSistema: number, numeroContrato: number, movi: Movi): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/movi/${idSistema}/${numeroContrato}`, movi, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public incluirMovimentosEmLote(loteCsv: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/movi/lote`, loteCsv, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public simularProCdd(idSistema: number, numeroContrato: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/endi/${idSistema}/${numeroContrato}/simular-pro-cdd`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  //------------CONSULTA--------------//

  public consultarContrato(idSistema: number, numeroContrato: number): Observable<Endi> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/endi/${idSistema}/${numeroContrato}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Endi>;
  }

  public calcularDigitoVerificador(numeroContratoCom10Digitos: number): Observable<number> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/endi/${numeroContratoCom10Digitos}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<number>;
  }

  public consultarSaldoDePrincipal(idSistema: number, numeroContrato: number): Observable<Sald> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/sald/${idSistema}/${numeroContrato}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Sald>;
  }

  public consultarMovimento(idSistema: number, numeroContrato: number): Observable<Movi[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/movi/${idSistema}/${numeroContrato}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Movi[]>;
  }

 //-------------EXCLUSÃO-------------//

  public excluirContrato(idSistema: number, numeroContrato: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/endi/${idSistema}/${numeroContrato}/remover`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public excluirSaldoDePrincipal(idSistema: number, numeroContrato: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/sald/${idSistema}/${numeroContrato}/remover`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public excluirMovimento(idSistema: number, numeroContrato: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/movi/${idSistema}/${numeroContrato}/remover`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public exluirProCdd(idSistema: number, numeroContrato: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/endi/${idSistema}/${numeroContrato}/remover-simulacao-pro-cdd`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  // ---------------------------- carga do RCC do FG2 ------------------------//

  public carregarRccFg2(): Observable<any> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/carga-rcc-fg2`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
}





